// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3_jzl","cardTop":"Card_cardTop__3DB4s","cardBottom":"Card_cardBottom__3_LM0"};